// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/*login css*/

input[type=text], input[type=password] {
  width: 100%;
  padding: 12px 40px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #18191F;
  box-sizing: border-box;
  border-radius: 10px;
}

/* Set a style for the buttons*/

button {
  background-color: black;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  cursor: pointer;
  width: 100%;
}

/* Set a hover effect for the button
        button:hover {  
            opacity: 0.8;  
        }  */

/* Set extra style for the cancel button*/

.container {
  padding: 16px;
}

.fontuser {
  position: relative;
}

.fontuser i {
  position: absolute;
  left: 15px;
  top: 24px;
  color: #18191F;
}

.fontpassword {
  position: relative;
}

.fontpassword i {
  position: absolute;
  left: 15px;
  top: 24px;
  color: #18191F;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #808080;
  font-family: 'montserrat-medium';
  font-size: 21px;
  line-height: 28px;
  font-weight: '500';
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #808080;
  font-family: 'montserrat-medium';
  font-size: 21px;
  line-height: 28px;
  font-weight: '500';
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #808080;
  font-family: 'montserrat-medium';
  font-size: 21px;
  line-height: 28px;
  font-weight: '500';
}

/*login css*/

.row {
  width: 100%;
}

/**/

.scrolldiv {
  /* for chrome and safari*/
  -webkit-animation-duration: 4s;
  -webkit-animation-name: slidein;
  /*for firefox*/
  -moz-animation-duration: 4s;
  -moz-animation-name: slidein;
  /* for opera*/
  -o-animation-duration: 1s;
  -o-animation-name: slidein;
  /* Standard syntax*/
  animation-duration: 4s;
  animation-name: slidein;
}

@keyframes slidein {
  from {
    margin-left: 100%;
    width: 300%;
  }
  to {
    margin-left: 0%;
    width: 100%;
  }
}

/**/

.boder_radius {
  background: linear-gradient(0deg, rgba(196, 214, 62, 0), rgba(196, 214, 62, 0)), #A9F2F9;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.hide {
  visibility: hidden;
}

.visible {
  visibility: visible;
}

.questionDivShow {
  visibility: hidden;
  animation: 1s linear 0s forwards delayedmoveFisrt;
}

@keyframes delayedmoveFisrt {
  from {
    visibility: visible;
    opacity: 0;
  }
  to {
    visibility: visible;
    opacity: 1;
  }
}

.imghoverdiv {
  display: none;
  margin-top: -10px;
  padding-top: 5px;
  position: relative;
  border: 1px solid black;
  /* width: 10%; */
  /* text-align: center; */
}

#imgmenu:hover+.imghoverdiv {
  display: block;
}

.imghoverdiv:hover {
  display: block;
}

.leftalign {
  /* margin-top:50px;margin-left:50px; */
  padding-bottom: 20px;
  font-size: 50px
}

.mobile-responsive {
  width: 768px;
  margin: 0 auto !important;
  float: none !important;
  position: relative;
  min-height: 100vh;
  border: 1px solid rgba(0, 0, 0, .125);
}

.mobile-responsive-ios {
  margin: 0 auto !important;
  float: none !important;
  position: relative;
  min-height: 97vh;
  border: 1px solid rgba(0, 0, 0, .125);
}

.module-content {
  height: 100%;
  width: 100%;
  /* overflow-y: scroll; */
}

.forward-step {
  /* position: fixed; */
  right: 0;
  /* bottom: 8%; */
  padding-right: 8%;
  /* width: 768px; */
  text-align: right;
}

.dashboard-img {
  display: inline-block;
  width: 100%;
  background-color: rgb(255, 189, 18);
  border-radius: 50%;
  margin: 10px;
}

.dashboard-img img {
  width: 90%;
  height: 90%;
}

.vertical-align {
  display: flex;
  align-items: center;
}

.center-page {
  width: 100%;
  height: 100vh;
  align-items: center;
}

.dashboard-level {
  height: 70px;
  border-radius: 16px;
  border: 2px solid #18191F;
  position: relative;
  margin: 0 auto;
  max-width: 70px;
}

.font-17-14 {
  font-size: 17px;
}

.font-24-18 {
  font-size: 24px;
}

.font-20-18 {
  font-size: 20px;
}

.image-with-thinking-bg {}

.footer-tab {
  position: fixed;
  bottom: 0px;
  background-color: rgb(255, 255, 255);
  box-shadow: rgb(24 25 31) 0px 1px 0px inset;
  padding-top: 10px;
  width: 768px;
}

@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .mobile-responsive {
    width: 100% !important;
  }
  .footer-tab {
    width: 100% !important;
  }
  /* .forward-step { 
    width: 100% !important;
  } */
}

@media only screen and (max-height: 568px) {
  /* Iphone 5: */
  .dashboard {
    max-height: 88vh;
    overflow-y: scroll;
  }
}

@media only screen and (max-width: 330px) {
  .font-17-14 {
    font-size: 14px;
  }
  .font-24-18 {
    font-size: 18px;
  }
  .font-20-18 {
    font-size: 18px;
  }
}

.custom-invalid-feedback {
  width: 100%;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}

.custom-invalid {
  border-color: #dc3545 !important;
}

.boxHeight {
  background-color: rgb(0, 198, 174);
  border-radius: 0px 0px 32px 32px;
  min-height: 40vh;
}

.level-margin {
  margin-top: 15px;
}

.lego_profile {
  width: 65px !important;
  padding: 5px;
}

@media screen and (min-height: 600px) {
  .boxHeight {
    min-height: 48vh;
  }
  .vertical-align {
    margin-top: 4vh;
  }
  .point-margin {
    margin-top: 3vh;
  }
  .level-margin {
    margin-top: 5vh;
  }
  .level-heading {
    margin-top: 2vh !important;
  }
  .module-box {
    margin-top: 1.2vh;
  }
  .circle-text-top {
    margin-top: 0.5vh;
    margin-bottom: 0.5vh;
  }
  .circle-margin {
    margin-top: 5vh !important;
  }
  .forward-step {
    /* bottom: 5% !important; */
  }
}

@media screen and (min-height: 800px) {
  .boxHeight {
    min-height: 55vh;
  }
  .level-heading {
    margin-top: 4vh !important;
  }
  .module-box {
    margin-top: 3vh;
  }
  .box-margin, .checkbox-margin {
    margin-top: 50px !important;
  }
  .circle-text-top {
    margin-top: 0.5vh;
    margin-bottom: 0.5vh;
  }
  .circle-margin {
    margin-top: 10vh !important;
  }
  .drag-margin {
    margin-top: 5vh !important;
  }
}

.char-limit {
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.align-left {
  text-align: left;
}

.says-content {
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
}

@media screen and (max-width: 360px) {
  .imgttext>p>span {
    /* background-color: red; */
    font-size: 14px !important;
  }
}

.tamil  .imgttext>p>span{
  font-size: 11px !important;
}
@media screen and (max-width: 320px) {
  .intro-saystext>p>span {
    /* background-color: red; */
    font-size: 11px !important;
  }
  .intro-header>p>span {
    /* background-color: red; */
    font-size: 14px !important;
  }
  .single-image-text>p>span {
    font-size: 13px !important;
  }
  .single-image-header>p>span {
    font-size: 13px !important;
  }
  .msp-header>p>span {
    font-size: 17px !important;
  }
  .msp-body>p>span {
    font-size: 14px !important;
  }
  .msp-btmtxt>p>span {
    font-size: 12px !important;
  }
  .msp-question>p>span {
    font-size: 12px !important;
  }
  .msp-question>p, .msp-body>p {
    line-height: 18px !important;
  }
  .bottom-style>div>a>img {
    width: 35px !important;
    height: 35px !important;
  }
  .audiospeak-img>a>img {
    width: 37px !important;
    height: 37px !important;
    left: 17px !important;
  }
  .audiospeak-img>a>img>img {}
  .repeat-img {
    width: 30px !important;
    height: 30px !important;
  }
  .progress-div {
    font-size: 12px;
  }
  .record-text {
    padding-top: .5rem!important;
  }
  .st-btn-text>p {
    font-size: 8px !important;
  }
}

.rectextIssue>p>span {
  font-size: 20px !important;
}

.rectextType {
  font-family: "montserrat-medium";
}

.barDesign {
  /* background-color: #FFFFFF !important; */
  border-radius: 1.25rem !important;
}

.barDesign>.progress-bar {
  border-radius: 16px !important;
}

html {
  scroll-behavior: smooth;
}

@media screen and (max-width: 600px) {
  .record-font>p>span, .record-font>div {
    font-size: 11px !important;
  }
  .record-font>p {
    line-height: 15px;
    text-align: start !important;
  }
  .record-text {
    font-size: 15px !important;
  }
}

.record-text {
  font-size: 18px;
  color: #8094FF;
  font-weight: 700;
  font-family: montserrat-medium
}

@media screen and (min-height: 800px) {
  .st-img-bg {
    width: 120px;
    height: 120px;
    background-color: rgb(255, 189, 18);
    border-radius: 60px;
  }
  .st-img {
    width: 125px;
    height: 270px;
    margin-top: -10px;
  }
  .st-bg-green {
    background-color: rgb(0, 198, 174);
    height: 270px;
    border-radius: 0px 0px 32px 32px;
  }
  .margin-space {
    margin-top: 120px;
  }
  .img_1 {
    width: 50px;
    height: 50px;
  }
  .img_2 {
    width: 50px;
    height: 50px;
  }
  .img_3 {
    width: 60px;
    height: 55px;
  }
  .img_font {
    text-align: start;
    font-size: 23px;
    font-family: montserrat-medium;
    color: rgb(0, 0, 0);
    font-weight: 700;
    white-space: nowrap;
  }
  .heading_text {
    margin-top: 35px;
    text-align: start;
    font-weight: 800;
    font-size: 30px;
    font-family: montserrat-extrabold;
    margin-left: 20px;
  }
  .heder_sub_text {
    text-align: start;
    font-family: montserrat-medium;
    margin-left: 20px;
    font-size: 22px;
  }
  .row-space-btn {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .row-space {
    margin-top: 30px;
  }
  .mar-top-row {
    margin-top: 140px;
  }
  .st-btn-text {
    background-color: rgb(97, 228, 197);
    border-radius: 18px;
    border-width: 2px;
    border-color: black;
    border-style: solid;
    text-align: center;
    padding-top: 12px;
    font-weight: 700;
    font-size: 18px;
  }
}

@media screen and (max-height: 800px) {
  .st-img-bg {
    width: 100px;
    height: 100px;
    background-color: rgb(255, 189, 18);
    border-radius: 50px;
  }
  .st-img {
    width: 100px;
    height: 220px;
    margin-top: -10px;
  }
  .st-bg-green {
    background-color: rgb(0, 198, 174);
    height: 220px;
    border-radius: 0px 0px 32px 32px;
  }
  .img_1 {
    width: 35px;
    height: 33px;
  }
  .img_2 {
    width: 35px;
    height: 33px;
  }
  .img_3 {
    width: 35px;
    height: 33px;
  }
  .margin-space {
    margin-top: 50px;
  }
  .img_font {
    text-align: start;
    font-size: 19px;
    font-family: montserrat-medium;
    color: rgb(0, 0, 0);
    font-weight: 700;
  }
  .heading_text {
    margin-top: 25px;
    text-align: start;
    font-weight: 800;
    font-size: 28px;
    font-family: montserrat-extrabold;
  }
  .heder_sub_text {
    text-align: start;
    font-family: montserrat-medium;
    font-size: 18px;
  }
  .row-space {
    margin-top: 30px;
  }
  .row-space-btn {
    margin-top: 20px;
  }
  .mar-top-row {
    margin-top: 50px;
  }
  .st-btn-text {
    background-color: rgb(97, 228, 197);
    border-radius: 15px;
    border-width: 2px;
    border-color: black;
    border-style: solid;
    text-align: center;
    padding-top: 14px;
    font-weight: 700;
    font-size: 14px;
  }
}

@media screen and (max-height: 570px) {
  .forward-step>a>img {
    width: 35px !important;
    height: 35px !important;
  }
  .rocket-image {
    width: 45px !important;
    height: 40px !important;
  }
  .drag-text_1>p {
    line-height: 18px !important;
  }
  .drag-text_2>p {
    line-height: 16px !important;
    text-align: center;
  }
  .question-font>p>span {
    font-size: 12px !important;
  }
  .positionremove {
    position: unset !important;
  }
  .heading_text, .heder_sub_text {
    padding-left: 10px;
  }
  .singala .question-title>p>span {
    font-size: 9px !important;
  }
  .img_font {
    margin-bottom: 0!important;
  }
  .row-space-btn {
    margin-top: 2px;
  }
  
  .img_font {
    font-size: 14px;
  }
  .heading_text {
    font-size: 20px;
  }
  .intro-header {
    font-size: 20px;
  }
  .intro-saystext>p {
    line-height: 17px;
  }
  .intro-img {
    width: 90px !important;
  }
  .tamil .intro-saystext {
    font-size: 9px !important;
  }
  .tamilintro {
    /* position: unset !important; */
  }
}

.bottom-style {
  position: absolute;
  bottom: 0px;
  padding: 0px 10px 10px;
  width: 100%;
  z-index: 1;
  /* background: rgb(255, 255, 255); */
  max-width: 768px;
}

.progress-div {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 10px
}

.module-content {
  /* margin-bottom: 100px; */
}

#root {
  /* margin-bottom: 100px; */
}

@media screen and (max-height: 850px) {
  .tamil .img_font {
    font-size: 12px;
  }
  .tamil .heading_text {
    font-size: 18px;
  }
  .tamil .heder_sub_text {
    font-size: 15px;
  }
  .tamil .st-btn-text>P {
    font-size: 10px;
  }
  .singala .img_font {
    font-size: 12px;
  }
  .singala .heading_text {
    font-size: 18px;
  }
  .singala .heder_sub_text {
    font-size: 15px;
  }
  .singala .st-btn-text>P {
    font-size: 10px;
  }
}

.horizontal .bottom-style {
  position: absolute;
}

.audio-scroll {
  overflow: auto;
}

.center-loader {
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
}

/* width */

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */

::-webkit-scrollbar-thumb {
  background: 808080;
  border-radius: 10px;
}

/* Handle on hover */

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.module-parent {
  padding-bottom: 90px;
}
.module-parent-meet-single-person {
  padding-bottom: 66px;
}

.module-parent-audio-screen {
  padding-bottom: 76px;
}
.audio-img {
  display: block;
  max-width: 100%;
  height: auto;
}
.circl-img-style{
  width: 63%;
  padding-left: 10px;
  padding-top: 14%;
  font-size: 10px;
  font-family: "montserrat-medium";
}
.tamil .circl-img-style{
  padding-top: 9%;
}
.horizontal .audio-img{
min-height: 20vh;
}
.audio-img{
  min-height: 10vh;
}

@media screen and (max-height: 640px) {
.img-size-askGender{
 width: 105px !important;
 height: 230px !important;
}
.askGender-divHeight{
  height: 200px !important;
}
.askAge-divHeight{
  height: 200px !important;
}
.img-size-askAge{
  width: 105px !important;
  height: 230px !important;
}
}

@media screen and (max-width: 450px) {
  .img-size-askAge{
    width: 130px !important;
    height: 250px !important;
    margin-right: 10px;
    padding-right: 10px;
  }
  .askAge-divHeight{
    height: 200px !important;
  }
  .img-size-askGender{
    width: 130px !important;
    height: 250px !important;
    margin-right: 15px;
    padding-right: 10px;
   }
   .askGender-divHeight{
     height: 200px !important;
   }
}


/*****/
.dynamic-form p {
  margin-bottom: 0;
}

.app-content {
  text-align: left;
}

.app-content .mobile-responsive {
  width: 768px;
  height: 100vh;
  margin: 0 auto !important;
  float: none !important;
  position: relative;
  border: 1px solid rgba(0, 0, 0, .125);
}


@media only screen and (max-width: 768px) {
  .app-content .mobile-responsive {
    width: 100% !important;
  }
}
/***/
.dropback {
  background: #ecf1f5;
  border-radius: 15px;
  padding: 30px;
  width: 100%;
}
.lb1 {
  background-color: #4d95cb;
  color: #fff;
  border-bottom-right-radius: 50px;
  text-align: center;
  font-weight: bold;
}
.dragimgph {
  width: 100px;
  height: 100px;
  /* margin-left: 40%; */
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.modal-header .modal-close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
  background-color: transparent;
  border: 0;
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-shadow: 0 1px 0 #fff;
  cursor: pointer;
}
.tabs-vertical {
  background: #607d8b;
  color: #fff;
}
.tabs-vertical .tab {
  padding: 10px;
  border-bottom: 0.5px solid #9e9e9e;
  font-weight: bold;
  cursor: pointer;
}
.tabs-vertical .tab.active {
  background: #cddc39;
}
.theme-bg{
  background-color: rgb(0, 198, 174) !important;
}
.header {
  display: flex;
  height: 50px;
  background: gray;
}
.newParentsBody{
  width: 100%;
  height: 100vh;
  background-color: #FCE880;
  display: flex;
  flex-direction:column;
}
.newParentsBody .headers{
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.newParentsBody .headtext{
white-space: nowrap;
color: #DD3B96;
font-family: "Fredoka";
}
.newParentsBody .backbtn{
  width: 10%;
}
.newParentsBody .headerStr{
  font-size: 30px;
}
.newParentsBody .trackProgress{
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.newParentsBody .trackProgressTxt{
  font-family: "Fredoka";
  font-size: 22px;
}
.trackProgressLineTxt{
  font-family: "Fredoka";
  font-size: 16px;
}

.trackProgBody{
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction:column;
}
.trackProgBody .emotionChat{
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction:column;
  background-color: #85A3D3;
}
.trackProgBody .strategies{
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction:column;
  background-color: #FF8D8D;
  align-items: center;
  justify-content: center;
}
.trackProgBody .headers{
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.trackProgBody .headtext{
white-space: nowrap;
color: #060606;
font-family: "Fredoka";
}
.trackProgBody .emotionChatBoxContainer{
  width: 100%;
  height: 100%;
}
.trackProgBody .emotionChatBox{
  width: 60%;
  height: auto;
  background-color: #fff;
  border-radius: 20px;
}
.trackProgBody .containerOne{
  width: 100%;
  height: 43px;
  background-color: #517BC0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 15px;
}
.trackProgBody .headingemotion{
  font-size: 23px;
  color: #fff;
  font-family: "Fredoka";
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.trackProgBody .latestemotionText{
  font-family: "Fredoka";
  color: #4D4D4D;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.trackProgBody .emojicontainer{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.trackProgBody .emotionType{
  font-family: "Fredoka";
  font-size: 22px;
  color: #4D4D4D;
}
.trackProgBody .latestemotions{
border-top: 2px dashed #C7C7C7;
position: relative;
}
.trackProgBody .emotionscheck{
  font-family: "Fredoka";
  color: #4D4D4D;
}
@media only screen and (max-width: 800px) {
  .trackProgBody .emotionChatBox{
    width: 80% !important;
  }
  .trackProgBody .container_strategies{
    width: 80% !important;
  }
}
@media only screen and (max-width: 375px) {
  .trackProgBody .emotionChatBox{
    width: 80%;
  }
  .trackProgBody .emotion_emoji{
    width: 60px !important;
  }
  .trackProgBody .emotionType{
    font-family: "Fredoka";
    font-size: 18px;
    color: #4D4D4D;
  }
  .trackProgBody .headingemotion{
    font-size: 20px;
  }
  .trackProgBody .emotionscheck{
font-size: 14px !important;  
}
.trackProgBody .emotionChat{
  width: 100%;
  height: 55%;
  display: flex;
  flex-direction:column;
  background-color: #85A3D3;
}
.trackProgBody .strategies{
  width: 100%;
  height: 45%;
  display: flex;
  flex-direction:column;
  background-color: #FF8D8D;
  align-items: center;
  justify-content: center;
}
}

.trackProgBody .emotions_list{
display: flex;
flex-direction: row;
align-items: center;
justify-content: center;
padding: 5px;
}
.trackProgBody .emo_box{
  position: absolute;
  top:3px;
  width: 100%;
}
.trackProgBody .latestseven_Emoji{
  width:33px !important;
}

@media only screen and (max-width:384px) {
  .trackProgBody .emotion_emoji{
    width: 70px !important;
  }
  .trackProgBody .latestseven_Emoji{
    width:25px !important;
  }
}
@media only screen and (max-width:360px) {
  .trackProgBody .ABCDE_Strategies_Txt{
    font-size: 14px !important;
  }

}
.trackProgBody .container_strategies{
  width: 60%;
  height: auto;
  background-color: #FF8D8D;
  border-radius: 20px;
 
}
.trackProgBody .tabs {
  display: flex;
  height: 45px;
  line-height: 40px;
  font-weight: bold;
  overflow: auto;
}

.trackProgBody .tabs .tab {
  text-align: center;
  cursor: pointer;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom: none;
  color: #517BC0;
  width:100%;
  background-color: rgba(255, 255, 255, .5);
  font-family: "Fredoka";
  font-size: 18px;

}

.trackProgBody .tabs .tab.active {
  background-color: #ffffff;
  color: #DD3B96;
}
.trackProgBody .stg_games{
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  width: 100%;
  height: 37vh;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
 overflow: hidden;
}
.trackProgBody .ABCDE_Strategies_Txt{
  font-family: "Fredoka";
  font-size: 16px;
  color: #4D4D4D;
  padding: 5px;
}
.trackProgBody .ABCDE_Strategies_games{
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 2px dashed #C7C7C7;
  height: 12vh;
margin-bottom: 5px;}
.trackProgBody .gameTitle{
  display: flex;
  flex-direction: column;
}
.trackProgBody .gameName{
  font-family: "Fredoka";
  font-size: 18px;
  color: #4D4D4D;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

}
.trackProgBody .gameLikes{
  font-family: "Fredoka";
  font-size: 14px;
  color: #4D4D4D;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.trackProgBody  .gmHeader{
  height: 35px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,YAAY;;AAEZ;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+BAA+B;;AAE/B;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;;;YAGY;;AAEZ,yCAAyC;;AAEzC;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,YAAY;;AAEZ;EACE,WAAW;AACb;;AAEA,GAAG;;AAEH;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAmCA;EACE;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA,GAAG;;AAEH;EACE,wFAAwF;EACxF,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB;AACF;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,yBAAyB;;AAEzB;EACE,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,2CAA2C;EAC3C,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;;KAEG;AACL;;AAEA;EACE,cAAc;EACd;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EAEb,WAAW;EACX,kCAAkC;AACpC;;AAEA,WAAW;;AAWX;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;EACA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;EACvB;EACA,2BAA2B;EAC3B;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,kCAAkC;IAClC,aAAa;IACb,gCAAgC;EAClC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,kCAAkC;IAClC,aAAa;IACb,gCAAgC;EAClC;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iCAAiC;EACnC;EACA;IACE,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,mCAAmC;IACnC,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;IAC5B,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,eAAe;AACjB;;AAEA,UAAU;;AAEV;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,oBAAoB;;AAEpB;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;AACA,gBAAgB;AAChB;AACA;EACE,gBAAgB;AAClB;;AAEA;AACA;CACC,uBAAuB;CACvB,wBAAwB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;;AAEA;EACE;IACE,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;GACpB;GACA;KACE,wBAAwB;GAC1B;AACH;;;AAGA,MAAM;AACN;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;AACvC;;;AAGA;EACE;IACE,sBAAsB;EACxB;AACF;AACA,IAAI;AACJ;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;AACA,mBAAmB;AACnB,cAAc;AACd,sBAAsB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;AACA,mBAAmB;AACnB,cAAc;AACd,sBAAsB;AACtB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;AACA;AACA,8BAA8B;AAC9B,kBAAkB;AAClB;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;AACF,0BAA0B;AAC1B;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;AAEA;AACA,aAAa;AACb,mBAAmB;AACnB,mBAAmB;AACnB,uBAAuB;AACvB,YAAY;AACZ;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;;AAEF;AACA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;;AAErB;AACA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,yCAAyC;EACzC,sBAAsB;EACtB,eAAe;;AAEjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;CACjC,gBAAgB;AACjB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;AACd,kBAAkB,CAAC;AACnB;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;;AAE7B;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/*login css*/\n\ninput[type=text], input[type=password] {\n  width: 100%;\n  padding: 12px 40px;\n  margin: 8px 0;\n  display: inline-block;\n  border: 1px solid #18191F;\n  box-sizing: border-box;\n  border-radius: 10px;\n}\n\n/* Set a style for the buttons*/\n\nbutton {\n  background-color: black;\n  color: white;\n  padding: 14px 20px;\n  margin: 8px 0;\n  border: none;\n  cursor: pointer;\n  width: 100%;\n}\n\n/* Set a hover effect for the button\n        button:hover {  \n            opacity: 0.8;  \n        }  */\n\n/* Set extra style for the cancel button*/\n\n.container {\n  padding: 16px;\n}\n\n.fontuser {\n  position: relative;\n}\n\n.fontuser i {\n  position: absolute;\n  left: 15px;\n  top: 24px;\n  color: #18191F;\n}\n\n.fontpassword {\n  position: relative;\n}\n\n.fontpassword i {\n  position: absolute;\n  left: 15px;\n  top: 24px;\n  color: #18191F;\n}\n\n::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #808080;\n  font-family: 'montserrat-medium';\n  font-size: 21px;\n  line-height: 28px;\n  font-weight: '500';\n}\n\n:-ms-input-placeholder {\n  /* Internet Explorer 10-11 */\n  color: #808080;\n  font-family: 'montserrat-medium';\n  font-size: 21px;\n  line-height: 28px;\n  font-weight: '500';\n}\n\n::-ms-input-placeholder {\n  /* Microsoft Edge */\n  color: #808080;\n  font-family: 'montserrat-medium';\n  font-size: 21px;\n  line-height: 28px;\n  font-weight: '500';\n}\n\n/*login css*/\n\n.row {\n  width: 100%;\n}\n\n/**/\n\n.scrolldiv {\n  /* for chrome and safari*/\n  -webkit-animation-duration: 4s;\n  -webkit-animation-name: slidein;\n  /*for firefox*/\n  -moz-animation-duration: 4s;\n  -moz-animation-name: slidein;\n  /* for opera*/\n  -o-animation-duration: 1s;\n  -o-animation-name: slidein;\n  /* Standard syntax*/\n  animation-duration: 4s;\n  animation-name: slidein;\n}\n\n@-webkit-keyframes slidein {\n  from {\n    margin-left: 100%;\n    width: 300%;\n  }\n  to {\n    margin-left: 0%;\n    width: 100%;\n  }\n}\n\n@-moz-keyframes slidein {\n  from {\n    margin-left: 100%;\n    width: 300%;\n  }\n  to {\n    margin-left: 0%;\n    width: 100%;\n  }\n}\n\n@-o-keyframes slidein {\n  from {\n    margin-left: 100%;\n    width: 300%;\n  }\n  to {\n    margin-left: 0%;\n    width: 100%;\n  }\n}\n\n@keyframes slidein {\n  from {\n    margin-left: 100%;\n    width: 300%;\n  }\n  to {\n    margin-left: 0%;\n    width: 100%;\n  }\n}\n\n/**/\n\n.boder_radius {\n  background: linear-gradient(0deg, rgba(196, 214, 62, 0), rgba(196, 214, 62, 0)), #A9F2F9;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n}\n\n.hide {\n  visibility: hidden;\n}\n\n.visible {\n  visibility: visible;\n}\n\n.questionDivShow {\n  visibility: hidden;\n  animation: 1s linear 0s forwards delayedmoveFisrt;\n}\n\n@keyframes delayedmoveFisrt {\n  from {\n    visibility: visible;\n    opacity: 0;\n  }\n  to {\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n.imghoverdiv {\n  display: none;\n  margin-top: -10px;\n  padding-top: 5px;\n  position: relative;\n  border: 1px solid black;\n  /* width: 10%; */\n  /* text-align: center; */\n}\n\n#imgmenu:hover+.imghoverdiv {\n  display: block;\n}\n\n.imghoverdiv:hover {\n  display: block;\n}\n\n.leftalign {\n  /* margin-top:50px;margin-left:50px; */\n  padding-bottom: 20px;\n  font-size: 50px\n}\n\n.mobile-responsive {\n  width: 768px;\n  margin: 0 auto !important;\n  float: none !important;\n  position: relative;\n  min-height: 100vh;\n  border: 1px solid rgba(0, 0, 0, .125);\n}\n\n.mobile-responsive-ios {\n  margin: 0 auto !important;\n  float: none !important;\n  position: relative;\n  min-height: 97vh;\n  border: 1px solid rgba(0, 0, 0, .125);\n}\n\n.module-content {\n  height: 100%;\n  width: 100%;\n  /* overflow-y: scroll; */\n}\n\n.forward-step {\n  /* position: fixed; */\n  right: 0;\n  /* bottom: 8%; */\n  padding-right: 8%;\n  /* width: 768px; */\n  text-align: right;\n}\n\n.dashboard-img {\n  display: inline-block;\n  width: 100%;\n  background-color: rgb(255, 189, 18);\n  border-radius: 50%;\n  margin: 10px;\n}\n\n.dashboard-img img {\n  width: 90%;\n  height: 90%;\n}\n\n.vertical-align {\n  display: flex;\n  align-items: center;\n}\n\n.center-page {\n  width: 100%;\n  height: 100vh;\n  align-items: center;\n}\n\n.dashboard-level {\n  height: 70px;\n  border-radius: 16px;\n  border: 2px solid #18191F;\n  position: relative;\n  margin: 0 auto;\n  max-width: 70px;\n}\n\n.font-17-14 {\n  font-size: 17px;\n}\n\n.font-24-18 {\n  font-size: 24px;\n}\n\n.font-20-18 {\n  font-size: 20px;\n}\n\n.image-with-thinking-bg {}\n\n.footer-tab {\n  position: fixed;\n  bottom: 0px;\n  background-color: rgb(255, 255, 255);\n  box-shadow: rgb(24 25 31) 0px 1px 0px inset;\n  padding-top: 10px;\n  width: 768px;\n}\n\n@media only screen and (max-width: 768px) {\n  /* For mobile phones: */\n  .mobile-responsive {\n    width: 100% !important;\n  }\n  .footer-tab {\n    width: 100% !important;\n  }\n  /* .forward-step { \n    width: 100% !important;\n  } */\n}\n\n@media only screen and (max-height: 568px) {\n  /* Iphone 5: */\n  .dashboard {\n    max-height: 88vh;\n    overflow-y: scroll;\n  }\n}\n\n@media only screen and (max-width: 330px) {\n  .font-17-14 {\n    font-size: 14px;\n  }\n  .font-24-18 {\n    font-size: 18px;\n  }\n  .font-20-18 {\n    font-size: 18px;\n  }\n}\n\n.custom-invalid-feedback {\n  width: 100%;\n  font-size: 80%;\n  color: #dc3545;\n  text-align: left;\n}\n\n.custom-invalid {\n  border-color: #dc3545 !important;\n}\n\n.boxHeight {\n  background-color: rgb(0, 198, 174);\n  border-radius: 0px 0px 32px 32px;\n  min-height: 40vh;\n}\n\n.level-margin {\n  margin-top: 15px;\n}\n\n.lego_profile {\n  width: 65px !important;\n  padding: 5px;\n}\n\n@media screen and (min-height: 600px) {\n  .boxHeight {\n    min-height: 48vh;\n  }\n  .vertical-align {\n    margin-top: 4vh;\n  }\n  .point-margin {\n    margin-top: 3vh;\n  }\n  .level-margin {\n    margin-top: 5vh;\n  }\n  .level-heading {\n    margin-top: 2vh !important;\n  }\n  .module-box {\n    margin-top: 1.2vh;\n  }\n  .circle-text-top {\n    margin-top: 0.5vh;\n    margin-bottom: 0.5vh;\n  }\n  .circle-margin {\n    margin-top: 5vh !important;\n  }\n  .forward-step {\n    /* bottom: 5% !important; */\n  }\n}\n\n@media screen and (min-height: 800px) {\n  .boxHeight {\n    min-height: 55vh;\n  }\n  .level-heading {\n    margin-top: 4vh !important;\n  }\n  .module-box {\n    margin-top: 3vh;\n  }\n  .box-margin, .checkbox-margin {\n    margin-top: 50px !important;\n  }\n  .circle-text-top {\n    margin-top: 0.5vh;\n    margin-bottom: 0.5vh;\n  }\n  .circle-margin {\n    margin-top: 10vh !important;\n  }\n  .drag-margin {\n    margin-top: 5vh !important;\n  }\n}\n\n.char-limit {\n  display: block;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.loader {\n  border: 16px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 16px solid #3498db;\n  width: 120px;\n  height: 120px;\n  -webkit-animation: spin 2s linear infinite;\n  /* Safari */\n  animation: spin 2s linear infinite;\n}\n\n/* Safari */\n\n@-webkit-keyframes spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.align-left {\n  text-align: left;\n}\n\n.says-content {\n  padding-left: 10px;\n  padding-right: 10px;\n  text-align: center;\n}\n\n@media screen and (max-width: 360px) {\n  .imgttext>p>span {\n    /* background-color: red; */\n    font-size: 14px !important;\n  }\n}\n\n.tamil  .imgttext>p>span{\n  font-size: 11px !important;\n}\n@media screen and (max-width: 320px) {\n  .intro-saystext>p>span {\n    /* background-color: red; */\n    font-size: 11px !important;\n  }\n  .intro-header>p>span {\n    /* background-color: red; */\n    font-size: 14px !important;\n  }\n  .single-image-text>p>span {\n    font-size: 13px !important;\n  }\n  .single-image-header>p>span {\n    font-size: 13px !important;\n  }\n  .msp-header>p>span {\n    font-size: 17px !important;\n  }\n  .msp-body>p>span {\n    font-size: 14px !important;\n  }\n  .msp-btmtxt>p>span {\n    font-size: 12px !important;\n  }\n  .msp-question>p>span {\n    font-size: 12px !important;\n  }\n  .msp-question>p, .msp-body>p {\n    line-height: 18px !important;\n  }\n  .bottom-style>div>a>img {\n    width: 35px !important;\n    height: 35px !important;\n  }\n  .audiospeak-img>a>img {\n    width: 37px !important;\n    height: 37px !important;\n    left: 17px !important;\n  }\n  .audiospeak-img>a>img>img {}\n  .repeat-img {\n    width: 30px !important;\n    height: 30px !important;\n  }\n  .progress-div {\n    font-size: 12px;\n  }\n  .record-text {\n    padding-top: .5rem!important;\n  }\n  .st-btn-text>p {\n    font-size: 8px !important;\n  }\n}\n\n.rectextIssue>p>span {\n  font-size: 20px !important;\n}\n\n.rectextType {\n  font-family: \"montserrat-medium\";\n}\n\n.barDesign {\n  /* background-color: #FFFFFF !important; */\n  border-radius: 1.25rem !important;\n}\n\n.barDesign>.progress-bar {\n  border-radius: 16px !important;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n@media screen and (max-width: 600px) {\n  .record-font>p>span, .record-font>div {\n    font-size: 11px !important;\n  }\n  .record-font>p {\n    line-height: 15px;\n    text-align: start !important;\n  }\n  .record-text {\n    font-size: 15px !important;\n  }\n}\n\n.record-text {\n  font-size: 18px;\n  color: #8094FF;\n  font-weight: 700;\n  font-family: montserrat-medium\n}\n\n@media screen and (min-height: 800px) {\n  .st-img-bg {\n    width: 120px;\n    height: 120px;\n    background-color: rgb(255, 189, 18);\n    border-radius: 60px;\n  }\n  .st-img {\n    width: 125px;\n    height: 270px;\n    margin-top: -10px;\n  }\n  .st-bg-green {\n    background-color: rgb(0, 198, 174);\n    height: 270px;\n    border-radius: 0px 0px 32px 32px;\n  }\n  .margin-space {\n    margin-top: 120px;\n  }\n  .img_1 {\n    width: 50px;\n    height: 50px;\n  }\n  .img_2 {\n    width: 50px;\n    height: 50px;\n  }\n  .img_3 {\n    width: 60px;\n    height: 55px;\n  }\n  .img_font {\n    text-align: start;\n    font-size: 23px;\n    font-family: montserrat-medium;\n    color: rgb(0, 0, 0);\n    font-weight: 700;\n    white-space: nowrap;\n  }\n  .heading_text {\n    margin-top: 35px;\n    text-align: start;\n    font-weight: 800;\n    font-size: 30px;\n    font-family: montserrat-extrabold;\n    margin-left: 20px;\n  }\n  .heder_sub_text {\n    text-align: start;\n    font-family: montserrat-medium;\n    margin-left: 20px;\n    font-size: 22px;\n  }\n  .row-space-btn {\n    margin-top: 10px;\n    margin-bottom: 10px;\n  }\n  .row-space {\n    margin-top: 30px;\n  }\n  .mar-top-row {\n    margin-top: 140px;\n  }\n  .st-btn-text {\n    background-color: rgb(97, 228, 197);\n    border-radius: 18px;\n    border-width: 2px;\n    border-color: black;\n    border-style: solid;\n    text-align: center;\n    padding-top: 12px;\n    font-weight: 700;\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-height: 800px) {\n  .st-img-bg {\n    width: 100px;\n    height: 100px;\n    background-color: rgb(255, 189, 18);\n    border-radius: 50px;\n  }\n  .st-img {\n    width: 100px;\n    height: 220px;\n    margin-top: -10px;\n  }\n  .st-bg-green {\n    background-color: rgb(0, 198, 174);\n    height: 220px;\n    border-radius: 0px 0px 32px 32px;\n  }\n  .img_1 {\n    width: 35px;\n    height: 33px;\n  }\n  .img_2 {\n    width: 35px;\n    height: 33px;\n  }\n  .img_3 {\n    width: 35px;\n    height: 33px;\n  }\n  .margin-space {\n    margin-top: 50px;\n  }\n  .img_font {\n    text-align: start;\n    font-size: 19px;\n    font-family: montserrat-medium;\n    color: rgb(0, 0, 0);\n    font-weight: 700;\n  }\n  .heading_text {\n    margin-top: 25px;\n    text-align: start;\n    font-weight: 800;\n    font-size: 28px;\n    font-family: montserrat-extrabold;\n  }\n  .heder_sub_text {\n    text-align: start;\n    font-family: montserrat-medium;\n    font-size: 18px;\n  }\n  .row-space {\n    margin-top: 30px;\n  }\n  .row-space-btn {\n    margin-top: 20px;\n  }\n  .mar-top-row {\n    margin-top: 50px;\n  }\n  .st-btn-text {\n    background-color: rgb(97, 228, 197);\n    border-radius: 15px;\n    border-width: 2px;\n    border-color: black;\n    border-style: solid;\n    text-align: center;\n    padding-top: 14px;\n    font-weight: 700;\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-height: 570px) {\n  .forward-step>a>img {\n    width: 35px !important;\n    height: 35px !important;\n  }\n  .rocket-image {\n    width: 45px !important;\n    height: 40px !important;\n  }\n  .drag-text_1>p {\n    line-height: 18px !important;\n  }\n  .drag-text_2>p {\n    line-height: 16px !important;\n    text-align: center;\n  }\n  .question-font>p>span {\n    font-size: 12px !important;\n  }\n  .positionremove {\n    position: unset !important;\n  }\n  .heading_text, .heder_sub_text {\n    padding-left: 10px;\n  }\n  .singala .question-title>p>span {\n    font-size: 9px !important;\n  }\n  .img_font {\n    margin-bottom: 0!important;\n  }\n  .row-space-btn {\n    margin-top: 2px;\n  }\n  \n  .img_font {\n    font-size: 14px;\n  }\n  .heading_text {\n    font-size: 20px;\n  }\n  .intro-header {\n    font-size: 20px;\n  }\n  .intro-saystext>p {\n    line-height: 17px;\n  }\n  .intro-img {\n    width: 90px !important;\n  }\n  .tamil .intro-saystext {\n    font-size: 9px !important;\n  }\n  .tamilintro {\n    /* position: unset !important; */\n  }\n}\n\n.bottom-style {\n  position: absolute;\n  bottom: 0px;\n  padding: 0px 10px 10px;\n  width: 100%;\n  z-index: 1;\n  /* background: rgb(255, 255, 255); */\n  max-width: 768px;\n}\n\n.progress-div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0px 10px\n}\n\n.module-content {\n  /* margin-bottom: 100px; */\n}\n\n#root {\n  /* margin-bottom: 100px; */\n}\n\n@media screen and (max-height: 850px) {\n  .tamil .img_font {\n    font-size: 12px;\n  }\n  .tamil .heading_text {\n    font-size: 18px;\n  }\n  .tamil .heder_sub_text {\n    font-size: 15px;\n  }\n  .tamil .st-btn-text>P {\n    font-size: 10px;\n  }\n  .singala .img_font {\n    font-size: 12px;\n  }\n  .singala .heading_text {\n    font-size: 18px;\n  }\n  .singala .heder_sub_text {\n    font-size: 15px;\n  }\n  .singala .st-btn-text>P {\n    font-size: 10px;\n  }\n}\n\n.horizontal .bottom-style {\n  position: absolute;\n}\n\n.audio-scroll {\n  overflow: auto;\n}\n\n.center-loader {\n  margin: auto;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  position: fixed;\n}\n\n/* width */\n\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n}\n\n/* Handle */\n\n::-webkit-scrollbar-thumb {\n  background: 808080;\n  border-radius: 10px;\n}\n\n/* Handle on hover */\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.module-parent {\n  padding-bottom: 90px;\n}\n.module-parent-meet-single-person {\n  padding-bottom: 66px;\n}\n\n.module-parent-audio-screen {\n  padding-bottom: 76px;\n}\n.audio-img {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n.circl-img-style{\n  width: 63%;\n  padding-left: 10px;\n  padding-top: 14%;\n  font-size: 10px;\n  font-family: \"montserrat-medium\";\n}\n.tamil .circl-img-style{\n  padding-top: 9%;\n}\n.horizontal .audio-img{\nmin-height: 20vh;\n}\n.audio-img{\n  min-height: 10vh;\n}\n\n@media screen and (max-height: 640px) {\n.img-size-askGender{\n width: 105px !important;\n height: 230px !important;\n}\n.askGender-divHeight{\n  height: 200px !important;\n}\n.askAge-divHeight{\n  height: 200px !important;\n}\n.img-size-askAge{\n  width: 105px !important;\n  height: 230px !important;\n}\n}\n\n@media screen and (max-width: 450px) {\n  .img-size-askAge{\n    width: 130px !important;\n    height: 250px !important;\n    margin-right: 10px;\n    padding-right: 10px;\n  }\n  .askAge-divHeight{\n    height: 200px !important;\n  }\n  .img-size-askGender{\n    width: 130px !important;\n    height: 250px !important;\n    margin-right: 15px;\n    padding-right: 10px;\n   }\n   .askGender-divHeight{\n     height: 200px !important;\n   }\n}\n\n\n/*****/\n.dynamic-form p {\n  margin-bottom: 0;\n}\n\n.app-content {\n  text-align: left;\n}\n\n.app-content .mobile-responsive {\n  width: 768px;\n  height: 100vh;\n  margin: 0 auto !important;\n  float: none !important;\n  position: relative;\n  border: 1px solid rgba(0, 0, 0, .125);\n}\n\n\n@media only screen and (max-width: 768px) {\n  .app-content .mobile-responsive {\n    width: 100% !important;\n  }\n}\n/***/\n.dropback {\n  background: #ecf1f5;\n  border-radius: 15px;\n  padding: 30px;\n  width: 100%;\n}\n.lb1 {\n  background-color: #4d95cb;\n  color: #fff;\n  border-bottom-right-radius: 50px;\n  text-align: center;\n  font-weight: bold;\n}\n.dragimgph {\n  width: 100px;\n  height: 100px;\n  /* margin-left: 40%; */\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.modal-header .modal-close {\n  padding: 1rem 1rem;\n  margin: -1rem -1rem -1rem auto;\n  background-color: transparent;\n  border: 0;\n  float: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n  color: #fff;\n  text-shadow: 0 1px 0 #fff;\n  cursor: pointer;\n}\n.tabs-vertical {\n  background: #607d8b;\n  color: #fff;\n}\n.tabs-vertical .tab {\n  padding: 10px;\n  border-bottom: 0.5px solid #9e9e9e;\n  font-weight: bold;\n  cursor: pointer;\n}\n.tabs-vertical .tab.active {\n  background: #cddc39;\n}\n.theme-bg{\n  background-color: rgb(0, 198, 174) !important;\n}\n.header {\n  display: flex;\n  height: 50px;\n  background: gray;\n}\n.newParentsBody{\n  width: 100%;\n  height: 100vh;\n  background-color: #FCE880;\n  display: flex;\n  flex-direction:column;\n}\n.newParentsBody .headers{\n  width: 100%;\n  height: 70px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.newParentsBody .headtext{\nwhite-space: nowrap;\ncolor: #DD3B96;\nfont-family: \"Fredoka\";\n}\n.newParentsBody .backbtn{\n  width: 10%;\n}\n.newParentsBody .headerStr{\n  font-size: 30px;\n}\n.newParentsBody .trackProgress{\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n.newParentsBody .trackProgressTxt{\n  font-family: \"Fredoka\";\n  font-size: 22px;\n}\n.trackProgressLineTxt{\n  font-family: \"Fredoka\";\n  font-size: 16px;\n}\n\n.trackProgBody{\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  flex-direction:column;\n}\n.trackProgBody .emotionChat{\n  width: 100%;\n  height: 50vh;\n  display: flex;\n  flex-direction:column;\n  background-color: #85A3D3;\n}\n.trackProgBody .strategies{\n  width: 100%;\n  height: 50vh;\n  display: flex;\n  flex-direction:column;\n  background-color: #FF8D8D;\n  align-items: center;\n  justify-content: center;\n}\n.trackProgBody .headers{\n  width: 100%;\n  height: 70px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.trackProgBody .headtext{\nwhite-space: nowrap;\ncolor: #060606;\nfont-family: \"Fredoka\";\n}\n.trackProgBody .emotionChatBoxContainer{\n  width: 100%;\n  height: 100%;\n}\n.trackProgBody .emotionChatBox{\n  width: 60%;\n  height: auto;\n  background-color: #fff;\n  border-radius: 20px;\n}\n.trackProgBody .containerOne{\n  width: 100%;\n  height: 43px;\n  background-color: #517BC0;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding-top: 15px;\n}\n.trackProgBody .headingemotion{\n  font-size: 23px;\n  color: #fff;\n  font-family: \"Fredoka\";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n.trackProgBody .latestemotionText{\n  font-family: \"Fredoka\";\n  color: #4D4D4D;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n.trackProgBody .emojicontainer{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n.trackProgBody .emotionType{\n  font-family: \"Fredoka\";\n  font-size: 22px;\n  color: #4D4D4D;\n}\n.trackProgBody .latestemotions{\nborder-top: 2px dashed #C7C7C7;\nposition: relative;\n}\n.trackProgBody .emotionscheck{\n  font-family: \"Fredoka\";\n  color: #4D4D4D;\n}\n@media only screen and (max-width: 800px) {\n  .trackProgBody .emotionChatBox{\n    width: 80% !important;\n  }\n  .trackProgBody .container_strategies{\n    width: 80% !important;\n  }\n}\n@media only screen and (max-width: 375px) {\n  .trackProgBody .emotionChatBox{\n    width: 80%;\n  }\n  .trackProgBody .emotion_emoji{\n    width: 60px !important;\n  }\n  .trackProgBody .emotionType{\n    font-family: \"Fredoka\";\n    font-size: 18px;\n    color: #4D4D4D;\n  }\n  .trackProgBody .headingemotion{\n    font-size: 20px;\n  }\n  .trackProgBody .emotionscheck{\nfont-size: 14px !important;  \n}\n.trackProgBody .emotionChat{\n  width: 100%;\n  height: 55%;\n  display: flex;\n  flex-direction:column;\n  background-color: #85A3D3;\n}\n.trackProgBody .strategies{\n  width: 100%;\n  height: 45%;\n  display: flex;\n  flex-direction:column;\n  background-color: #FF8D8D;\n  align-items: center;\n  justify-content: center;\n}\n}\n\n.trackProgBody .emotions_list{\ndisplay: flex;\nflex-direction: row;\nalign-items: center;\njustify-content: center;\npadding: 5px;\n}\n.trackProgBody .emo_box{\n  position: absolute;\n  top:3px;\n  width: 100%;\n}\n.trackProgBody .latestseven_Emoji{\n  width:33px !important;\n}\n\n@media only screen and (max-width:384px) {\n  .trackProgBody .emotion_emoji{\n    width: 70px !important;\n  }\n  .trackProgBody .latestseven_Emoji{\n    width:25px !important;\n  }\n}\n@media only screen and (max-width:360px) {\n  .trackProgBody .ABCDE_Strategies_Txt{\n    font-size: 14px !important;\n  }\n\n}\n.trackProgBody .container_strategies{\n  width: 60%;\n  height: auto;\n  background-color: #FF8D8D;\n  border-radius: 20px;\n \n}\n.trackProgBody .tabs {\n  display: flex;\n  height: 45px;\n  line-height: 40px;\n  font-weight: bold;\n  overflow: auto;\n}\n\n.trackProgBody .tabs .tab {\n  text-align: center;\n  cursor: pointer;\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n  border-bottom: none;\n  color: #517BC0;\n  width:100%;\n  background-color: rgba(255, 255, 255, .5);\n  font-family: \"Fredoka\";\n  font-size: 18px;\n\n}\n\n.trackProgBody .tabs .tab.active {\n  background-color: #ffffff;\n  color: #DD3B96;\n}\n.trackProgBody .stg_games{\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #ffffff;\n  width: 100%;\n  height: 37vh;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n overflow: hidden;\n}\n.trackProgBody .ABCDE_Strategies_Txt{\n  font-family: \"Fredoka\";\n  font-size: 16px;\n  color: #4D4D4D;\n  padding: 5px;\n}\n.trackProgBody .ABCDE_Strategies_games{\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-bottom: 2px dashed #C7C7C7;\n  height: 12vh;\nmargin-bottom: 5px;}\n.trackProgBody .gameTitle{\n  display: flex;\n  flex-direction: column;\n}\n.trackProgBody .gameName{\n  font-family: \"Fredoka\";\n  font-size: 18px;\n  color: #4D4D4D;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n\n}\n.trackProgBody .gameLikes{\n  font-family: \"Fredoka\";\n  font-size: 14px;\n  color: #4D4D4D;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n.trackProgBody  .gmHeader{\n  height: 35px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
